// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bn_d2","cartIcon":"bn_d2","badge":"bn_d3"};